<template>
  <div class="sidebar">
    <div class="sidebar__logo">
      <logotype/>
    </div>
    <md-list :md-expand-single="expandSingle" class="sidebar__menu">

      <md-list-item md-expand :md-ripple="false">
        <md-icon md-src="/static/img/dashboard_icon.svg"/>
        <span class="md-list-item-text">{{ i18n.lbl_dashboard() }}</span>

        <md-list slot="md-expand">
          <md-list-item :md-ripple="false" @click="closeSidebar" to="/dashboard">
            <md-icon md-src="/static/img/wallet_icon.svg"/>
            <span class="md-list-item-text">{{ i18n.lbl_my_wallet() }}</span>
          </md-list-item>
          <md-list-item v-if="config.FEATURE_FLAGS.history && accountTypeI !== ACCOUNT_TYPES.notVerified && accountState !== 'pending'"
                        :md-ripple="false"
                        @click="closeSidebar"
                        to="/history">
            <md-icon md-src="/static/img/transaction_history_icon.svg"/>
            <span class="md-list-item-text">{{ i18n.lbl_history() }}</span>
          </md-list-item>
          <md-list-item v-if="config.FEATURE_FLAGS.refundHistory && refundHistory" :md-ripple="false" @click="closeSidebar" to="/refund-history">
            <md-icon md-src="/static/img/transaction_history_icon.svg"/>
            <span class="md-list-item-text">{{ i18n.lbl_refund_history() }}</span>
          </md-list-item>
        </md-list>
      </md-list-item>
      <md-list-item v-if="accountTypeI !== ACCOUNT_TYPES.notVerified && accountState !== 'pending'" md-expand :md-ripple="false">
        <md-icon md-src="/static/img/transactions_icon.svg"/>
        <span class="md-list-item-text">{{ i18n.lbl_transactions() }}</span>

        <md-list slot="md-expand">
          <md-list-item v-if="config.FEATURE_FLAGS.cashbox && cashbox" @click="closeSidebar" to="/cashbox">
            <md-icon md-src="/static/img/account-cash-icon.svg"/>
            <span class="md-list-item-text">{{ i18n.lbl_cashbox() }}</span>
          </md-list-item>

          <md-list-item v-if="config.FEATURE_FLAGS.widrawalRequest && widrawalRequest" :md-ripple="false" @click="closeSidebar" to="/withdrawal-req">
            <md-icon md-src="/static/img/account-cash-icon.svg"/>
            <span class="md-list-item-text">{{ i18n.lbl_withdrawal_req() }}</span>
          </md-list-item>

          <md-list-item v-if="config.FEATURE_FLAGS.topupBalance" :md-ripple="false" @click="closeSidebar" to="/topup-balance">
            <md-icon md-src="/static/img/top_up_icon.svg"/>
            <span class="md-list-item-text">{{ i18n.lbl_refill() }}</span>
          </md-list-item>

          <md-list-item v-if="config.FEATURE_FLAGS.withdrawal" :md-ripple="false" @click="closeSidebar" to="/withdrawal">
            <md-icon md-src="/static/img/withdraw_icon.svg"/>
            <span class="md-list-item-text">{{ i18n.lbl_withdraw() }}</span>
          </md-list-item>

          <md-list-item v-if="config.FEATURE_FLAGS.transfers" :md-ripple="false" @click="closeSidebar" to="/transfers">
            <md-icon md-src="/static/img/send_icon.svg"/>
            <span class="md-list-item-text">{{ i18n.lbl_send() }}</span>
          </md-list-item>

          <md-list-item v-if="config.FEATURE_FLAGS.massTransfers" :md-ripple="false" @click="closeSidebar" to="/mass-transfers">
            <md-icon md-src="/static/img/masstransfer_icon.svg"/>
            <span class="md-list-item-text">{{ i18n.lbl_send_mass() }}</span>
          </md-list-item>

        </md-list>
      </md-list-item>

      <md-list-item v-if="!systemAccount && accountTypeI !== ACCOUNT_TYPES.notVerified && accountState !== 'pending'" md-expand :md-ripple="false">
        <md-icon md-src="/static/img/projects_icon.svg"/>
        <span class="md-list-item-text">{{ i18n.lbl_projects() }}</span>

        <md-list slot="md-expand">
          <md-list-item v-if="config.FEATURE_FLAGS.saleCreation && accountTypeI === ACCOUNT_TYPES.syndicate"
                        :md-ripple="false"
                        @click="closeSidebar"
                        to="/sale-creation">
            <md-icon md-src="/static/img/project_create_icon.svg"/>
            <span class="md-list-item-text">{{ i18n.lbl_create_sale() }}</span>
          </md-list-item>

          <md-list-item v-if="config.FEATURE_FLAGS.sales && accountTypeI === ACCOUNT_TYPES.syndicate"
                        :md-ripple="false"
                        @click="closeSidebar"
                        to="/my-sales">
            <md-icon md-src="/static/img/my_project_icon.svg"/>
            <span class="md-list-item-text">{{ i18n.lbl_my_funds() }}</span>
          </md-list-item>

          <md-list-item v-if="config.FEATURE_FLAGS.sales"
                        :md-ripple="false"
                        @click="closeSidebar"
                        to="/sales">
            <md-icon md-src="/static/img/explore_project_icon.svg"/>
            <span class="md-list-item-text">{{ i18n.lbl_explore_sales() }}</span>
          </md-list-item>

          <md-list-item v-if="config.FEATURE_FLAGS.portfolio  && !systemAccount"
                        :md-ripple="false"
                        @click="closeSidebar"
                        to="/portfolio" >
            <md-icon md-src="/static/img/investment_icon.svg"/>
            <span class="md-list-item-text">{{ i18n.lbl_investment_portfolio() }}</span>
          </md-list-item>

          <md-list-item v-if="config.FEATURE_FLAGS.requests && accountTypeI === ACCOUNT_TYPES.syndicate && !systemAccount"
                        :md-ripple="false"
                        @click="closeSidebar"
                        to="/requests">
            <md-icon md-src="/static/img/requests_icon.svg"/>
            <span class="md-list-item-text">{{ i18n.lbl_requests() }}</span>
          </md-list-item>

          <md-list-item v-if="config.FEATURE_FLAGS.tokens"
                        @click="closeSidebar" to="/tokens">
            <md-icon>toll</md-icon>
            <span class="md-list-item-text">{{ i18n.lbl_explore_tokens() }}</span>
          </md-list-item>
        </md-list>
      </md-list-item>

      <md-list-item v-if="systemAccount && config.FEATURE_FLAGS.tokens" @click="closeSidebar" to="/tokens">
        <md-icon>toll</md-icon>
        <span class="md-list-item-text">{{ i18n.lbl_explore_tokens() }}</span>
      </md-list-item>

      <md-list-item v-if="config.FEATURE_FLAGS.myFees && accountTypeI !== ACCOUNT_TYPES.notVerified && accountState !== 'pending'"
                    :md-ripple="false"
                    @click="closeSidebar"
                    to="/fee">
        <md-icon md-src="/static/img/fees_icon.svg"/>
        <span class="md-list-item-text">{{ i18n.lbl_fee() }}</span>
      </md-list-item>

      <md-list-item v-if="config.FEATURE_FLAGS.limits && (accountTypeI === ACCOUNT_TYPES.syndicate || accountTypeI === ACCOUNT_TYPES.general)"
                    :md-ripple="false"
                    @click="closeSidebar"
                    to="/limits">
        <md-icon md-src="/static/img/limits_icon.svg"/>
        <span class="md-list-item-text">{{ i18n.lbl_limits() }}</span>
      </md-list-item>

      <md-list-item v-if="config.FEATURE_FLAGS.trade && accountTypeI !== ACCOUNT_TYPES.notVerified && accountState !== 'pending'"
                    :md-ripple="false"
                    @click="closeSidebar"
                    to="/trade">
        <md-icon md-src="/static/img/trade_icon.svg"/>
        <span class="md-list-item-text">{{ i18n.lbl_trade() }}</span>
      </md-list-item>

      <template v-if="accountState === 'nil' || accountState === 'rejected'">
        <md-divider></md-divider>
        <md-list-item v-if="config.FEATURE_FLAGS.verification"
                      :md-ripple="false"
                      @click="closeSidebar"
                      to="/verification">
          <md-icon>verified_user</md-icon>
          <span class="md-list-item-text">{{ i18n.lbl_verification() }}</span>
        </md-list-item>
      </template>

      <md-list-item @click="closeSidebar" to="/exchange"
                    v-if="config.FEATURE_FLAGS.trade && accountTypeI !== ACCOUNT_TYPES.notVerified && accountState !== 'pending'"
                    :md-ripple="false"
      >
        <md-icon>autorenew</md-icon>
        <span class="md-list-item-text">{{ i18n.lbl_exchange() }}</span>
      </md-list-item>

      <md-list-item @click="closeSidebar" to="/contracts"
                    v-if="!systemAccount && config.FEATURE_FLAGS.contracts && accountTypeI !== ACCOUNT_TYPES.notVerified && accountState !== 'pending'"
                    :md-ripple="false"
      >
        <md-icon>contact_mail</md-icon>
        <span class="md-list-item-text">{{ i18n.lbl_contracts() }}</span>
      </md-list-item>

      <md-list-item v-if="config.FEATURE_FLAGS.settings"
                    :md-ripple="false"
                    @click="closeSidebar()"
                    to="/settings">
        <md-icon md-src="/static/img/settings_icon.svg"/>
        <span class="md-list-item-text">{{ i18n.lbl_settings() }}</span>
      </md-list-item>

    </md-list>

    <app-footer/>
  </div>
</template>

<script>
  import config from '@conf'

  import { mapGetters } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { i18n } from '@js/i18n'
  import AppFooter from './Footer'
  import { ACCOUNT_TYPES } from '@const'
  import Logotype from '@vue/app/common/Logotype'
  import { commonEvents } from '@js/events/common_events'
  import { OBMENAT } from '@utils/consts'

  export default {
    name: 'sidebar',

    components: {
      AppFooter,
      Logotype
    },

    data () {
      return {
        isSidebarOpened: false,
        i18n,
        config,
        expandSingle: true,
        ACCOUNT_TYPES
      }
    },
    computed: {
      ...mapGetters([
        vuexTypes.userType,
        vuexTypes.userState,
        vuexTypes.userEmail,
        vuexTypes.accountTypeI,
        vuexTypes.accountState,
        vuexTypes.accountSignerName,
        vuexTypes.approverData,
        vuexTypes.accountBlocked
      ]),
      cashbox () {
        const name = this.accountSignerName
        return name ? name.toLowerCase().startsWith('cashbox') : false
      },
      widrawalRequest () {
        const isVisisble = this.approverData.approval_level && !this.accountBlocked
        return isVisisble
      },
      refundHistory () {
        return this.userEmail === OBMENAT.email
      },
      commissions () {
        const name = this.accountSignerName
        return name ? name.toLowerCase().startsWith('commission') : false
      },
      systemAccount () {
        let name = this.accountSignerName
        if (name) {
          name = name.toLowerCase()
          return name.startsWith('cashbox') || name.startsWith('operational') || name.startsWith('commission') || name.startsWith('kfy')
        }
        return false
      }
    },

    methods: {

      openSidebar () {
        this.isSidebarOpened = true
      },
      closeSidebar () {
        this.isSidebarOpened = false
        this.$emit('hide-sidebar', this.isSidebarOpened)
        this.$emit(commonEvents.closePopupEvent)
      },
      showPopup () {
        this.$emit(commonEvents.showPopupEvent)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~scss/mixins";

  .sidebar {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 30px;

    @include respond-to(small) {
      min-height: 100%;
      padding: 24px;
    }

    &__menu {
      flex: 1 1 auto;
      margin: 100px 0 48px;
      padding: 0;
    }

    .md-list {
      background: transparent;

      /deep/ .md-list-item-content {
        height: 64px;
        min-height: 64px;
        padding: 0;
        /*font-size: 16px;*/

        .md-icon:first-child {
          margin-right: 12px;
          @include respond-to(medium) {
            margin-right: 8px;
          }
        }
      }

      .md-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        color: $default-light-white;

        /deep/ svg {
          max-width: 24px;
          max-height: 24px;
        }

        /deep/ path,
        /deep/ rect {
          color: $default-light-white;
          fill:$default-light-white;
          fill-opacity: 1;
          transition: .3s;
        }
      }

      .md-list-item-text {
        @include font('main', $font-size-l, 600);
        color: $default-light-white;

        @include respond-to(medium) {
          @include font('main', $font-size-m, 600);
        }
      }

      /deep/ .md-list-item-container:not(.md-list-item-default):not(.md-list-item-expand):not([disabled]).router-link-active {
        &:hover {
          background-color: transparent;
        }
      }

      /deep/ .md-list-item-container:not(.md-list-item-default):not(.md-list-item-expand):not([disabled]):not(.router-link-active),
      /deep/ .md-list-item-expand:not(.md-list-item-default):not([disabled]) > .md-list-item-content { // styles for hovered menu item
        &:hover {
          background-color: transparent;

          & .md-icon:first-child {
            color: $yellow-push;
            fill: $yellow-push;
            & path,
              rect {
              color: $yellow-push;
              fill: $yellow-push;
            }
          }

          & .md-list-item-text {
            color: $yellow-push;
          }
        }
      }

      .router-link-active { // styles for active menu item

        & .md-list-item-text {
          color: $yellow-push;
        }

        & .md-icon {
          color: $yellow-push;

          & /deep/ path,
          /deep/ rect{
            color: $yellow-push;
            fill: $yellow-push;
          }
        }
      }

      .md-list-item-expand { // styles for active section title menu item
        border: none;

       /* &.md-active > .md-list-item-content {
          & .md-list-item-text {
            !*color: $sidebar-color-active;*!
          }

          .md-list-expand-icon,
          .md-icon {
            & /deep/ path,
            /deep/ rect{
           !*   color: $sidebar-color-active;
              fill: $sidebar-color-active;*!
            }
          }
        }*/

        & /deep/ .md-list-expand-icon { // styles for the native vue-material inactive expand-arrow icon
          & path:not([fill]) {
            fill: $default-light-white;
          }
        }
      }

      & /deep/ .md-list-expand {
        padding-left: 20px;

        & .md-list {
          padding: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/navigation/Sidebar.vue